import { ComEdFallbackExtension } from './comed.extension';
import { BGEFallbackExtension } from './bge.extension';
import { PECOFallbackExtension } from './peco.extension';
import { ACEFallbackExtension } from './ace.extension';
import { DPLFallbackExtension } from './dpl.extension';
import { PEPCOFallbackExtension } from './pepco.extension';

/**
 * this class allows the lazy initialization of opCo extensions to the local
 *  service (FallbackReportService). See the readme file for details.
 **/
export const Extensions = {
  ComEd: () => new ComEdFallbackExtension(),
  BGE: () => new BGEFallbackExtension(),
  PECO: () => new PECOFallbackExtension(),
  ACE: () => new ACEFallbackExtension(),
  DPL: () => new DPLFallbackExtension(),
  PEPCO: () => new PEPCOFallbackExtension(),
};
